import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxInput } from 'components/FormElements/ReduxForm'
// view components
import SearchResults from './components/SearchResults'
import ConfirmChangeParentPlanModal from 'components/Modals/ConfirmChangeParentPlanModal'
// views
import { Wrapper, SearchWrapper, SearchIconWrapper, CloseIcon, IconWrapper } from './views'
// icons
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
// themes
import { colors } from 'themes'
// constants
import { Forms } from 'constants/index'
// context
import { GlobalSearchAPIContext } from 'containers/GlobalSearch/layers/API'

const ICON_STYLE = { color: colors.white }

// types
interface IIncomingProps {
  isOpen: boolean
  isFocused: boolean
  isExpanded: boolean
  handleSetFocus: (value: boolean) => void
  toggleDrawer: () => void
}

interface IFormData {
  search: string
}

type IFormProps = InjectedFormProps<IFormData>

type IProps = IIncomingProps & IFormProps

const GlobalSearch: React.FunctionComponent<IProps> = ({
  handleSubmit,
  isFocused,
  isExpanded,
  handleSetFocus,
  toggleDrawer,
  reset
}) => {
  const { clearSearch, handleSearch } = React.useContext(GlobalSearchAPIContext)

  const inputRef = React.useRef(null)

  // methods
  const handleInputFocus = () => handleSetFocus(true)

  const handleFocusInput = () => {
    toggleDrawer()
    setTimeout(() => {
      if (inputRef.current && inputRef.current.focus) {
        inputRef.current.focus()
      }
    }, 500)
  }

  const closeSearch = () => {
    handleSetFocus(false)
    reset()
    clearSearch()
  }

  React.useEffect(() => {
    if (!isExpanded) {
      reset()
    }
  }, [isExpanded])

  return (
    <>
      {isExpanded ? (
        <Wrapper $isFocused={isFocused}>
          <form onSubmit={handleSubmit}>
            <SearchWrapper isFocused={isFocused}>
              <SearchIconWrapper>
                <SearchRoundedIcon style={ICON_STYLE} />
              </SearchIconWrapper>
              <ReduxInput
                disableUnderline
                handleInputChange={handleSearch}
                handleOnFocus={handleInputFocus}
                inputColor={colors.gray320}
                inputRef={inputRef}
                name={'search'}
                placeholder={'Search...'}
              />
              {isFocused && <CloseIcon onClick={closeSearch} />}
            </SearchWrapper>
            {isFocused && <SearchResults closeSearch={closeSearch} />}
          </form>
        </Wrapper>
      ) : (
        <IconWrapper onClick={handleFocusInput}>
          <SearchRoundedIcon style={ICON_STYLE} />
        </IconWrapper>
      )}

      <ConfirmChangeParentPlanModal />
    </>
  )
}

export default reduxForm<any>({
  form: Forms.GLOBAL_SEARCH_FORM,
  initialValues: {
    showActions: true,
    showKPIs: true,
    showObjectives: true,
    showPlans: true
  }
})(GlobalSearch)
